<template>
  <v-alert v-if="needRefresh"
           variant="elevated"
           elevation="5"
           color=""
           position="fixed"
           location="bottom right"
           style="z-index:9999"
           class="pa-3 ma-3">
    <h5 class="pt-3 pb-3 text-uppercase">There is an update available</h5>
  <v-btn @click="updateServiceWorker(true); doReload()" class="w-100" color="primary" variant="elevated">Update Page</v-btn>
  </v-alert>
</template>
<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue'
const {
  offlineReady,
  needRefresh,
  updateServiceWorker,
} = useRegisterSW()

const doReload = () => {
  window.setTimeout(() => {
    window.location.reload();
  },500)
}
async function close() {
  offlineReady.value = false
  needRefresh.value = false
}
</script>
